import { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

import QRLanding from "./QRLanding";
import { useTheme } from "../../context/ThemeContext";

export default function AuthLanding({
  themeColor,
  loggingIn,
  onGuestLogin,
  onGoogleLogin,
}) {

  const [accepted, setAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const { darkMode, setDarkMode } = useTheme();
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "light"
  );

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "var(--app-bg)",
        // Subtle mesh gradient using your theme color at 5% opacity
        backgroundImage: `radial-gradient(at 0% 0%, ${themeColor}10 0, transparent 50%), radial-gradient(at 100% 100%, ${themeColor}10 0, transparent 50%)`,
        padding: "20px"
      }}>
      <div
        className="card border-0 shadow-lg p-4 p-md-5 text-center"
        style={{
          maxWidth: "450px",
          borderRadius: "28px",
          backdropFilter: "blur(20px)",
          background: "color-mix(in srgb, var(--card-bg) 90%, transparent)",
          border: `1px solid ${themeColor}20`
        }}
      >
        {/* Loader Overlay */}
        {loggingIn && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
            style={{
              zIndex: 9999,
              backdropFilter: "blur(6px)",
              background: "color-mix(in srgb, var(--app-bg) 85%, transparent)"
            }}
          >
            <div
              className="spinner-border mb-3"
              style={{
                color: themeColor,
                width: "3rem",
                height: "3rem",
                borderWidth: "0.25em",
              }}
            />
            <div className="fw-bold text-muted small text-uppercase tracking-widest">
              Authenticating...
            </div>
          </div>
        )}

        {/* Logo */}
        <div className="mb-4">
          <div className="position-relative d-inline-block mb-4">
            {/* Glow effect behind logo */}
            <div className="position-absolute top-50 start-50 translate-middle"
              style={{
                width: "190px", height: "190px",
                backgroundColor: themeColor,
                filter: "blur(40px)", opacity: "0.15", zIndex: 0
              }}></div>

            <img
              src="/img/rrc.png"
              alt="Logo"
              className="position-relative img-fluid"
              style={{
                width: "180px", height: "180px",
                borderRadius: "22px", objectFit: "cover",
                zIndex: 1
              }}
            />
          </div>

          <h1 className="h3 fw-bold mt-2" style={{ color: "var(--text-color)", letterSpacing: "-0.5px" }}>
            Racket Riot <span style={{ color: themeColor }}>Club</span>
          </h1>
          <p className="text-muted small">Smarter match-making, faster games.</p>
        </div>

        {/* <h2 className="fw-black mb-2" style={{ color: "#2d3436" }}>
        Racket Riot Club
      </h2>
      <p className="text-muted mb-4">Choose how to continue</p> */}

        {/* Guest Login */}
        {/* <button
        className="btn btn-lg w-100 mb-3 fw-bold rounded-pill shadow-sm border"
        style={{ backgroundColor: "#fff", color: "#636e72" }}
        disabled={loggingIn}
        onClick={onGuestLogin}
      >
        <i className="bi bi-person me-2"></i>
        Continue as Guest
      </button> */}

        {/* Google Login */}
        <button
          className="btn w-100 py-3 rounded-pill d-flex align-items-center justify-content-center gap-3 mb-3"
          style={{
            backgroundColor: themeColor,
            color: "white",
            fontSize: "1rem",
            fontWeight: "600",
            boxShadow: `0 10px 20px ${themeColor}40`, // Theme-colored shadow
            transition: "all 0.3s ease",
            border: "none"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.filter = "brightness(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.filter = "brightness(1)";
          }}
          disabled={loggingIn || !accepted}
          onClick={onGoogleLogin}
        >
          <i className="bi bi-google me-2" />
          Sign in with Google
        </button>
        <div className="form-check mt-3 text-start">
          <input
            className="form-check-input"
            type="checkbox"
            id="acceptTerms"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
          <label className="form-check-label small text-muted" htmlFor="acceptTerms">
            I agree to the <i>Terms</i> & <i>Privacy Policy</i> and allow my profile and stats
            to be shown publicly.
          </label>
        </div>

        {/* <QRLanding scanning={scanning} setScanning={setScanning} themeColor={themeColor} handleLogout={handleLogout} /> */}
        <br />
        <br />

        {/* Legal */}
        <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
          <hr className="flex-grow-1 m-0 opacity-10" />
          <span
            className="small text-muted text-uppercase fw-bold tracking-widest"
            style={{ fontSize: "0.65rem" }}
          >
            Legal
          </span>
          <hr className="flex-grow-1 m-0 opacity-10" />
        </div>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <button
            type="button"
            className="btn btn-link p-0 fw-bold"
            style={{ fontSize: "0.75rem", color: themeColor }}
            onClick={() => setShowTerms(true)}
          >
            Privacy Policy
          </button>
          <span className="text-muted opacity-25">|</span>
          <button
            type="button"
            className="btn btn-link p-0 fw-bold"
            style={{ fontSize: "0.75rem", color: themeColor }}
            onClick={() => setShowTerms(true)}
          >
            Terms of Service
          </button>
        </div>


        <style>{`
        .fw-black { font-weight: 900; }
        .tracking-widest { letter-spacing: 0.15em; }
      `}</style>
        {showTerms && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div
                className="modal-content rounded-4 shadow"
                style={{
                  background: "var(--card-bg)",
                  color: "var(--text-color)",
                  border: "1px solid var(--border-color)"
                }}
              >
                <div className="modal-header border-0">
                  <h5 className="modal-title fw-bold">Terms & Privacy Summary</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowTerms(false)}
                  />
                </div>

                <div className="modal-body text-start small text-muted">
                  <p>
                    By using <strong>Racket Riot Club</strong>, you agree to the following:
                  </p>

                  <ul>
                    <li>We authenticate users via Google Sign-In.</li>
                    <li>Your display name and profile photo may be visible to other users.</li>
                    <li>Your game stats, queue participation, and match history may be publicly displayed.</li>
                    <li>We do not sell or rent your personal data.</li>
                    <li>Your data is securely stored using Google Firebase.</li>
                  </ul>

                  <p className="mt-3">
                    For full details, please read the complete documents:
                  </p>

                  <div className="d-flex gap-3">
                    <a
                      href="/terms-of-service.html"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: themeColor, fontWeight: 600 }}
                    >
                      Full Terms of Service
                    </a>
                    <a
                      href="/privacy-policy.html"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: themeColor, fontWeight: 600 }}
                    >
                      Full Privacy Policy
                    </a>
                  </div>
                </div>

                <div className="modal-footer border-0">
                  <button
                    className="btn btn-secondary rounded-pill"
                    onClick={() => setShowTerms(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <button
        onClick={() => setDarkMode(!darkMode)}
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          border: "none",
          background: "var(--card-bg)",
          color: "var(--text-color)",
          borderRadius: "999px",
          padding: "8px 12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          cursor: "pointer"
        }}
      >
        {!darkMode ? "🌙 Dark Mode" : "☀️ Light Mode"}
      </button>
    </div>
  );
}
